module.exports = __webpack_public_path__ + "static/img/new_sys_icon.0fd303b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_sys_icon.png
// module id = 64
// module chunks = 0